import initNumberedSection from "../NumberedSection.init";

document.addEventListener("DOMContentLoaded", () => {
  initNumberedSection();
});
